import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'

export default function CameraUpdater({ position, target, controlsRef }) {
    const { camera } = useThree()

    useEffect(() => {
        if (position) {
            camera.position.set(...position)

            // OrbitControlsのターゲットも更新
            if (controlsRef?.current) {
                // targetが指定されていればそれを使用、なければ0,0,0
                if (target) {
                    controlsRef.current.target.set(...target)
                    camera.lookAt(...target)
                } else {
                    controlsRef.current.target.set(0, 0, 0)
                    camera.lookAt(0, 0, 0)
                }
                controlsRef.current.update()
            } else {
                camera.lookAt(0, 0, 0)
            }
        }
    }, [position, target, camera, controlsRef])

    return null
}
